import { render } from "./ReceiptSearch.vue?vue&type=template&id=f4b785dc&scoped=true"
import script from "./ReceiptSearch.vue?vue&type=script&lang=js"
export * from "./ReceiptSearch.vue?vue&type=script&lang=js"

import "@/assets/style/table.css?vue&type=style&index=0&lang=css"
import "./ReceiptSearch.vue?vue&type=style&index=1&id=f4b785dc&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b785dc"]])

export default __exports__